<!--



NAO ESTÁ SENDO UTILIZADO

NOVO GUIA DA NFE: dashboard-guia-nfe


-->


<template>
  <!-- <div v-if="guia" class="guia-popover" style=""> -->
  <div class="guia-popover" style="">

    <div v-show="minimizado" class="guia-button" @click="handleMinimizar">
      <i class="float-right fa fa-mortar-board" aria-hidden="true" title="Guia de Primeiros Passos" data-toggle="tooltip"
        data-placement="top"></i>
    </div>

    <div v-if="!minimizado">
      <div class="guia-popover-content">
        <div v-if="!minimizado" class="row mx-auto align-items-center" style="border-bottom: 1px solid gray">
          <div class="col-12 mt-2 mb-2 p-3" @click="handleMinimizar" style="cursor: pointer">
            <span class="guia-title"> Guia primeiros passos </span>
            <i class="float-right guia-icon fa"
              :class="{ 'fa-chevron-circle-up': minimizado, 'fa-chevron-circle-down': !minimizado }"
              aria-hidden="true"></i>
          </div>
        </div>
        <div v-if="!minimizado" class="guia-list">
          <div class="guia-list__content">
            <div class="mainbox" v-for="(item, index) in guiaList" :key="index">
              <div class="box">
                <div class="row align-items-center">
                  <div class="col-2 text-center">
                    <i class="fa fa-play" style=""></i>
                  </div>
                  <div class="col-10" @click="handleShowVideo(index)" style="cursor: pointer">
                    <span class="data-list w-100">{{ item.title }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row">
                    <div class="col-12 mt-2 mb-2 text-center">
                        <a href="javascript:void(0);" @click="handleFecharGuia"> Fechar Guia </a>
                    </div>
                </div> -->
      </div>
    </div>

    <transition name="fade">
      <div v-if="currVideo" class="guia-video" @click="currVideo = null">
        <div class="guia-video-content text-center" style="width: 650px">
          <div class="row col justify-content-end">
            <button type="button" class="close" @click="handleCloseVideo" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <iframe width="560" height="315" :src="currVideo" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
            style="max-width: 800px"></iframe>
        </div>
      </div>
    </transition>

  </div>
</template>


<script>

import { apiORDSapp } from '../shared/api-functions'
import { SysVars } from '../main'

export default {
  props: {

  },

  data() {
    return {
      errmessages: null,  //armazena as mensagens de validacao do servidor para mostrar em tela

      minimizado: true,

      currVideo: null,

      listVideos: [
        // { app: 'nfe', title: 'Visão geral do nota brasil NF-e *****', url: '//www.youtube.com/embed/z0G5S0hxV4k'},
        { app: 'nfe', title: 'Configurar a empresa', url: '//www.youtube.com/embed/9aM1WjYSGjg' },
        { app: 'nfe', title: 'Configurar o certificado digital A1', url: '//www.youtube.com/embed/SWB17DsnAVM' },
        { app: 'nfe', title: 'Configurar o certificado digital A3', url: '//www.youtube.com/embed/Cnd3KgC9VsQ' },

        { app: 'nfe', title: 'Cadastrar um produto', url: '//www.youtube.com/embed/p7ifHw3lvx4' },
        { app: 'nfe', title: 'Importar cadastro de produtos', url: '//www.youtube.com/embed/jp75E6ezdpI' },
        { app: 'nfe', title: 'Produtos e configuração de impostos', url: '//www.youtube.com/embed/gjwdNe3q8AM' },

        { app: 'nfe', title: 'Cadastrar um cliente', url: '//www.youtube.com/embed/63sscsQRLgY' },
        { app: 'nfe', title: 'Importar cadastro de clientes e fornecedores', url: '//www.youtube.com/embed/eGD9DaZWoBc' },
        { app: 'nfe', title: 'Configurar regras de ICMS', url: '//www.youtube.com/embed/d4AgTK11q_s' },

        { app: 'nfe', title: 'Lançar uma venda', url: '//www.youtube.com/embed/QJC0ZLvBavc' },
        { app: 'nfe', title: 'Emitir uma nota fiscal', url: '//www.youtube.com/embed/sLgbQ0ZW2AQ' },

        { app: 'forcaVendas', title: 'Configurar os usuários', url: '//www.youtube.com/embed/kbZ9kTtajIA' },
      ]
    }
  },

  computed: {
    guiaList: function () {
      return this.listVideos.filter((obj) => {
        return obj.app == this.app
      })
    },

    app: function () {
      if (SysVars.appNFe)
        return 'nfe'
      else
        if (SysVars.appForcaVendas)
          return 'forcaVendas'
    },

    guia: function () {
      return SysVars.guia
    },
  },

  methods: {
    async apiPost() {
      // var params = '?uuid=' + SysVars.uuid
      var data = null
      const ativacao = await apiORDSapp(this, 'usuario/guia/', 'post', data)
      this.$appLoading(false)
    },

    handleCloseVideo(index) {
      this.currVideo = null
    },

    handleShowVideo(index) {
      this.currVideo = this.guiaList[index].url
    },

    handleMinimizar() {
      this.minimizado = !this.minimizado
      if (SysVars.guia) {
        this.apiPost()
        SysVars.guia = false
      }
    },

    handleFecharGuia() {
      this.apiPost()
      SysVars.guia = false
    },

  },

  watch: {
    guia: function (value) {
      if (value)
        this.minimizado = false
    }
  },

  components: {
  },

  beforeCreate() {

  },

  mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

  },

  created() {

  }

}

</script>




<style scoped>
.guia-popover {
  position: fixed;
  top: auto;
  left: auto;
  bottom: 20px;
  right: 20px;
  /* min-width: 300px; */
  display: inline-flex;
  align-items: center;
  z-index: 1;
  flex-direction: row;

}

.guia-popover-content {
  width: 100%;
  font: 400 15px/20px Source Sans Pro, sans-serif;
  color: #26292c;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 0 2px 0 #0000003d, 0 8px 10px 1px #0000000d, 0 3px 14px 2px #0000000f, 0 5px 5px -3px rgba(0, 0, 0, .1);
  order: 2;
}

.guia-list {
  max-height: 400px;
  display: flex;
  flex-direction: column;
}

.guia-list__content {
  overflow-y: auto;
  flex: 1 1 auto;
  padding: 8px 0;
}

.guia-title {
  font-size: 18px;
  font-weight: 600;
  color: #2b6292;
}


.box:hover {
  background-color: #f7f5f5;
}

.guia-button {
  z-index: 30;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 0 rgba(0, 0, 0, .5), 0 2px 10px rgba(0, 0, 0, .2);
  color: #2b6292;
  cursor: pointer;
  display: flex;
  height: 52px;
  width: 52px;
  justify-content: center;
  align-items: center;
  font-size: 18px;
}

.close {
  font-size: 5.0rem;
}
</style>



// WEBPACK FOOTER //
// src/forms/app-guia.vue